// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/TrackingPage.css */

.tracking-container {
    display: flex;
    height: 100vh;
    background: #f5f5f5;
  }
  
  .tracking-sidebar {
    width: 300px;
    padding: 1rem;
    background: #ffffff;
    border-right: 1px solid #ddd;
    box-shadow: 2px 0 6px rgba(0,0,0,0.05);
    overflow-y: auto;
  }
  
  .tracking-sidebar h2 {
    margin-top: 0;
    font-size: 1.25rem;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 0.5rem;
  }
  
  .tracking-sidebar .controls {
    margin: 1rem 0;
  }
  
  .tracking-sidebar .controls button {
    display: block;
    width: 100%;
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    font-size: 0.95rem;
    border: none;
    background: #007bff;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.2s;
  }
  
  .tracking-sidebar .controls button:hover {
    background: #0056b3;
  }
  
  .tracking-sidebar .date-filters label {
    display: block;
    margin-bottom: 0.75rem;
    font-size: 0.9rem;
  }
  
  .tracking-sidebar .date-filters input {
    width: 100%;
    padding: 0.4rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  .tracking-sidebar .courier-list {
    list-style: none;
    padding: 0;
    margin: 1rem 0;
  }
  
  .tracking-sidebar .courier-list li {
    margin-bottom: 0.5rem;
  }
  
  .tracking-sidebar .courier-list li.selected button {
    background: #28a745;
    color: #fff;
  }
  
  .tracking-sidebar .courier-list button {
    width: 100%;
    text-align: left;
    padding: 0.5rem;
    font-size: 0.95rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    transition: background 0.2s;
  }
  
  .tracking-sidebar .courier-list button:hover {
    background: #f0f0f0;
  }
  
  .tracking-main {
    flex: 1 1;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  
  .tracking-main .leaflet-container {
    flex: 1 1;
  }
  
  .tracking-placeholder {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    font-size: 1.1rem;
    border: 2px dashed #ccc;
    border-radius: 4px;
  }
  
  .leaflet-container {
    width: 100% !important;
    height: 100% !important;
    border-radius: 4px;
  }
  
  .leaflet-popup-content-wrapper {
    font-size: 0.9rem;
  }
  
  .leaflet-popup-content h4 {
    margin: 0 0 0.5rem;
    font-size: 1rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/modules/Admin/TrackingPage/TrackingPage.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,sCAAsC;IACtC,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB","sourcesContent":["/* src/pages/TrackingPage.css */\r\n\r\n.tracking-container {\r\n    display: flex;\r\n    height: 100vh;\r\n    background: #f5f5f5;\r\n  }\r\n  \r\n  .tracking-sidebar {\r\n    width: 300px;\r\n    padding: 1rem;\r\n    background: #ffffff;\r\n    border-right: 1px solid #ddd;\r\n    box-shadow: 2px 0 6px rgba(0,0,0,0.05);\r\n    overflow-y: auto;\r\n  }\r\n  \r\n  .tracking-sidebar h2 {\r\n    margin-top: 0;\r\n    font-size: 1.25rem;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    padding-bottom: 0.5rem;\r\n  }\r\n  \r\n  .tracking-sidebar .controls {\r\n    margin: 1rem 0;\r\n  }\r\n  \r\n  .tracking-sidebar .controls button {\r\n    display: block;\r\n    width: 100%;\r\n    margin-bottom: 0.5rem;\r\n    padding: 0.5rem;\r\n    font-size: 0.95rem;\r\n    border: none;\r\n    background: #007bff;\r\n    color: #fff;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background 0.2s;\r\n  }\r\n  \r\n  .tracking-sidebar .controls button:hover {\r\n    background: #0056b3;\r\n  }\r\n  \r\n  .tracking-sidebar .date-filters label {\r\n    display: block;\r\n    margin-bottom: 0.75rem;\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .tracking-sidebar .date-filters input {\r\n    width: 100%;\r\n    padding: 0.4rem;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .tracking-sidebar .courier-list {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 1rem 0;\r\n  }\r\n  \r\n  .tracking-sidebar .courier-list li {\r\n    margin-bottom: 0.5rem;\r\n  }\r\n  \r\n  .tracking-sidebar .courier-list li.selected button {\r\n    background: #28a745;\r\n    color: #fff;\r\n  }\r\n  \r\n  .tracking-sidebar .courier-list button {\r\n    width: 100%;\r\n    text-align: left;\r\n    padding: 0.5rem;\r\n    font-size: 0.95rem;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    background: #fff;\r\n    cursor: pointer;\r\n    transition: background 0.2s;\r\n  }\r\n  \r\n  .tracking-sidebar .courier-list button:hover {\r\n    background: #f0f0f0;\r\n  }\r\n  \r\n  .tracking-main {\r\n    flex: 1;\r\n    padding: 1rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n  }\r\n  \r\n  .tracking-main .leaflet-container {\r\n    flex: 1;\r\n  }\r\n  \r\n  .tracking-placeholder {\r\n    flex: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #666;\r\n    font-size: 1.1rem;\r\n    border: 2px dashed #ccc;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .leaflet-container {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .leaflet-popup-content-wrapper {\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .leaflet-popup-content h4 {\r\n    margin: 0 0 0.5rem;\r\n    font-size: 1rem;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
